import { jsxs as b, jsx as r } from "react/jsx-runtime";
import { c as Y } from "react/compiler-runtime";
import i from "moment-timezone";
const x = {
  label: {
    fontSize: "10px",
    color: "#5A5A5A",
    display: "flex"
  },
  input: {
    padding: "4px 8px",
    fontSize: "14px",
    cursor: "pointer",
    minWidth: "200px",
    borderRadius: "8px",
    border: "1px solid #EFEFEF",
    backgroundColor: "#F7F7F7",
    color: "#5A5A5A",
    fontWeight: 500,
    lineHeight: "14px",
    height: "32px"
  }
};
function c(l) {
  const e = Y(19), m = l.label ?? "Time";
  let a;
  e[0] !== m ? (a = /* @__PURE__ */ r("label", { children: /* @__PURE__ */ r("span", { style: x.label, children: m }) }), e[0] = m, e[1] = a) : a = e[1];
  let n;
  e[2] !== l.value ? (n = i(l.value).format("YYYY-MM-DDTHH:mm"), e[2] = l.value, e[3] = n) : n = e[3];
  let t;
  e[4] !== l.max ? (t = l.max ? i(l.max).format("YYYY-MM-DDTHH:mm") : void 0, e[4] = l.max, e[5] = t) : t = e[5];
  let o;
  e[6] !== l.min ? (o = l.min ? i(l.min).format("YYYY-MM-DDTHH:mm") : void 0, e[6] = l.min, e[7] = o) : o = e[7];
  let f;
  e[8] !== l ? (f = (h) => {
    const s = i(h.target.value).toDate();
    l.onChange(s);
  }, e[8] = l, e[9] = f) : f = e[9];
  let d;
  e[10] !== l.disabled || e[11] !== n || e[12] !== t || e[13] !== o || e[14] !== f ? (d = /* @__PURE__ */ r("input", { type: "datetime-local", style: x.input, value: n, max: t, min: o, disabled: l.disabled, onChange: f }), e[10] = l.disabled, e[11] = n, e[12] = t, e[13] = o, e[14] = f, e[15] = d) : d = e[15];
  let u;
  return e[16] !== a || e[17] !== d ? (u = /* @__PURE__ */ b("div", { children: [
    a,
    d
  ] }), e[16] = a, e[17] = d, e[18] = u) : u = e[18], u;
}
function A({
  startTime: l,
  endTime: e,
  onChange: m,
  min: a,
  max: n = i().toDate()
}) {
  return /* @__PURE__ */ b("div", { style: {
    display: "flex"
  }, children: [
    /* @__PURE__ */ r(c, { label: "From", value: l, min: a, max: e, disabled: i(l).isSameOrAfter(i(e)), onChange: (t) => {
      i(t).isSameOrAfter(i(e)) || m(t, e);
    } }),
    /* @__PURE__ */ r(c, { label: "To", value: e, min: l, max: n, disabled: i(e).isSameOrBefore(i(l)), onChange: (t) => {
      i(t).isSameOrBefore(i(l)) || m(l, t);
    } })
  ] });
}
export {
  A as DateTimePicker,
  c as TimeDateInput,
  c as default
};
